import './AddInvitationModal.scss';

export { default } from './AddInvitationModal';
